import Experience from '../Experience.js'
import * as THREE from 'three'  


/// Handles the Lighting and the Environment Map
// can also use this to traverse the scene and apply the environment map to all the meshes 
export default class Environment
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug

        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('Environment')
        }

        this.setSunLight()
        this.setEnvironmentMap()
    }
    
    setSunLight()
    {
        this.sunLight = new THREE.DirectionalLight('#ffffff', 4)
        this.sunLight.castShadow = true
        this.sunLight.shadow.camera.far = 15
        this.sunLight.shadow.mapSize.set(1024, 1024)
        this.sunLight.shadow.normalBias = 0.05
        //this.sunLight.position.set(3.5, 2, - 1.25)
        //this.sunLight.position.set(4, 4.6, 4.6)
        this.sunLight.position.set(4, -6, -10)
        this.scene.add(this.sunLight)

        //Debug
        if(this.debug.active)
        {
            this.debugFolder.add(this.sunLight, 'intensity').min(0).max(10).step(0.001).name('Sun Light Intensity').onChange(() => {
                this.sunLight.intensity = this.sunLight.intensity
            })
            this.debugFolder
                .add(this.sunLight.position, 'x')
                .name('SunLight X')
                .min(-10)
                .max(10)
                .step(0.1)
                .onChange(() => {
                    this.sunLight.position.set(this.sunLight.position.x, this.sunLight.position.y, this.sunLight.position.z)
                })
            this.debugFolder
                .add(this.sunLight.position, 'y')
                .name('SunLight Y')
                .min(-10)
                .max(10)
                .step(0.1)
                .onChange(() => {
                    this.sunLight.position.set(this.sunLight.position.x, this.sunLight.position.y, this.sunLight.position.z)
                })
            this.debugFolder
                .add(this.sunLight.position, 'z')
                .name('SunLight Z')
                .min(-10)
                .max(10)
                .step(0.1)
        }
    }

    setEnvironmentMap()
    {
        this.environmentMap = {}
        this.environmentMap.intensity = 0.4
        this.environmentMap.texture = this.resources.items.environmentMapTexture
        this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace

        this.scene.environment = this.environmentMap.texture

        this.environmentMap.updateMaterial = () =>
        {
            this.scene.traverse((child) =>
            {
                //console.log(child)
                if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
                {
                    child.material.envMap = this.environmentMap.texture
                    child.material.envMapIntensity = this.environmentMap.intensity
                    child.material.needsUpdate = true
                }
            })
        }

        this.environmentMap.updateMaterial()

        //Debug
        if(this.debug.active)
        {
            this.debugFolder.add(this.environmentMap, 'intensity').min(0).max(10).step(0.001).name('Environment Map Intensity').onChange(() => {
                this.environmentMap.updateMaterial()
            })
        }
    }
}